import globals from '../../globlas';
import { _paramsWithAxios, _sendWithAxios, _sendWithAxiosBlob, _sendWithAxiosProgress } from '../api';

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API

export const criarPasta = async (data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/criar-pasta`, 'POST', data);
}

export const editarPasta = async (data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/editar-pasta`, 'PUT', data);
}
export const editarPastaUpload = async (data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/editar-pasta-criacao`, 'PUT', data);
}

export const listarPastas = async (idUsuario, page, tamanho = 10) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/listar-pastas/${idUsuario}/${page}/${tamanho}`, 'GET');
}

export const listarPastasArquivos = async (idUsuario, page, tamanho = 10, ordem) => {
 
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/listar-pasta-arquivo/${idUsuario}/${tamanho}/${page}?orderBy=${ordem ? ordem : 'extensao asc, nomeOrdenacao asc'}`, 'GET');
}


export const  listarPastasPorFiltro = async (idUsuario, page, tamanho = 10, nomeDocumento, ordem) => {
  let nome = nomeDocumento ? nomeDocumento : '';
  
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/listar-pasta-arquivo-filtro/${idUsuario}/${page}/${tamanho}?orderBy=${ordem ? ordem : 'tipo asc, nomeOrdenacao asc'}&nomeDocumento=${nome}`, 'GET');
}

export const listarPastaFilha = async (idPasta) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/obter-filhos/${idPasta}`, 'GET');
}

export const detalhesPasta = async (idPasta) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/detalhe-pasta/${idPasta}`, 'GET');
}

export const renomearPasta = async (id, data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/renomear-pasta/${id}`, 'PUT', data);
}

export const inforPasta = async (id) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/info-pasta/${id}`, 'GET');
}

export const listarPastasArquivosInativos = async (tamanho = 5, pagina, filter, ordem) => {
  let filtro = '';
  if (filter)
    filtro = filter;

  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/listar-pasta-arquivo-inativo/${tamanho}/${pagina}${filtro}${filtro ? '&':'?'}orderBy=${ordem?ordem : 'dataInativacao asc'}`)
}

export const inativarPasta = async (idPasta, idUsuario) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/inativar-pasta/${idPasta}/${idUsuario}`, 'PUT');
}

export const inativarPastas = async (data, idUsuario) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/inativar-pastas/${idUsuario}`, 'PUT', data);
}

export const ativarPasta = async (idPasta) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/ativar-pasta/${idPasta}`, 'PUT');
}

export const obterPastasArquivosFilhos = async (idPasta, tamanho = 10, page, ordem) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/obter-pasta-arquivos-filhos/${idPasta}/${tamanho}/${page === null ? 1 : page }?orderBy=${ordem ? ordem : 'extensao asc, nomeOrdenacao asc'}`, 'GET');
}

export const obterPastasArquivosFilhosLinkCompartilhado = async (idUsuario, idPasta, tamanho = 10, page) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/obter-pasta-arquivos-filhos-link-compartilhado/${idUsuario}/${idPasta}/${tamanho}/${page}`, 'GET');
}

export const obterPastasSelecionadas = async (idUsuario, idsPastas) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/listar-pastas-selecionadas/${idUsuario}`, 'POST', idsPastas);
}

export const listarPastarArquivosPorNotificacao = async (idNotificacao, idUsuario) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/listar-pastas-arquivos-notificacao/${idNotificacao}/${idUsuario}`, 'GET');
}
export const listarPastarArquivosSolicitacaoPorNotificacao = async (idNotificacao) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/listar-pastas-arquivos-notificacao-solicitacao/${idNotificacao}`, 'GET');
}
export const adicionarPastarArquivosNotificacaoSolicitacao = async (idNotificacao, data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/adicionar-pastas-arquivos-notificacao-solicitacao/${idNotificacao}`, 'POST', data);
}
export const finalizarPastarArquivosNotificacaoSolicitacao = async (idNotificacao, data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/finalizar-pastas-arquivos-notificacao-solicitacao/${idNotificacao}`, 'POST', data);
}

export const listarPastarPorNome = async (idUsuario, nome, page, tamanho = 10) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/listar-pasta-filtro/${idUsuario}/${nome}/${page}/${tamanho}`, 'GET');
}

export const listarPastarTree = async (idUsuario) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/listar-pastas-tree/${idUsuario}`, 'GET');
}
export const verificarDuplacidade = async (nomeArquivo, idPasta) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/verificar-duplicidade/${nomeArquivo}?IdPasta=${idPasta}`, 'GET');
}

export const moverPastaArquivoDragInDrop = async (data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/mover-pasta-arquivo-dragindrop`, 'POST', data);
}

export const moverPastaDragInDrop = async (data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/mover-pastas`, 'POST', data);
}

export const copiarPastas = async (data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/copiar-pastas`, 'POST', data);
}

export const moverPastas = async (data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/mover-pastas`, 'POST', data);
}

export const historicoPastaAberta = async (idPasta) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/hierarquia-pasta/${idPasta}`, 'GET');
}

export const alterarClassificacaoPasta = async (idUsuario, idPasta, classificacao) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/alterar-classificacao/${idUsuario}/${idPasta}/${classificacao}`, 'PUT');
}

export const esvaziarLixeira = async () => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Pasta/esvaziar-lixeira`, 'POST');
}